<script>
import PageLayout from '../Components/UI/PageLayout.vue'
import MainContainer from '../Components/UI/Content/MainContainer.vue'
import MainContent from '../Components/UI/Content/MainContent.vue'
import AlertList from '../Components/Alert/AlertList.vue'
import Profitabilities from '../Components/Finance/Profitabilities.vue'
import Actors from '../Components/Actor/Actors.vue'
import Comments from '../Components/Comment/Comments.vue'
import ContractRestructuringView from '../Components/ContractRestructuring/ContractRestructuringView.vue'
import mixinComponent from '../Mixins/mixinComponent'
import { globalVariablesMixin } from '../Mixins/global'
import Outstanding from '../Components/Finance/Outstanding.vue'
import ContractCession from '../Components/Contract/ContractCession.vue'
import ContractSetup from '../Components/Contract/ContractSetup.vue'
import ContractDelivery from '../Components/Contract/ContractDelivery.vue'
import ContractDocument from '../Components/Contract/ContractDocument.vue'
import ContractAssetsAndServices from '../Components/Contract/ContractAssetsAndServices.vue'
import ContractInformation from '../Components/Contract/ContractInformation.vue'
import ContractMenu from '../Components/Contract/ContractMenu.vue'

export default {
  components: {
    Actors,
    AlertList,
    Comments,
    ContractAssetsAndServices,
    ContractCession,
    ContractDelivery,
    ContractDocument,
    ContractInformation,
    ContractMenu,
    ContractRestructuringView,
    ContractSetup,
    MainContainer,
    MainContent,
    Outstanding,
    PageLayout,
    Profitabilities,
  },
  mixins: [mixinComponent, globalVariablesMixin],
  inject: ['setValue'],

  data() {
    let urlParams = new URLSearchParams(window.location.search)
    return {
      contractId: urlParams.get('i'),
      contractNumber: null,
      contract: {
        id: urlParams.get('i'),
        number: null,
        withOrder: false,
        blockedAt: false,
        isDeliveryAvailable: false,
        finance: {
          tender: false,
        },
        status: 'CREATED',
      },
      contractLoaded: false,
      def: {},
      uuid: urlParams.get('u'),
      page: urlParams.get('p'),
      alertInformation: {
        status: '',
        number: 0,
        blocking: false,
      },
      showAlert: false,
      loadOutstandings: false,
      outstandings: [],
    }
  },

  computed: {
    titleMessage() {
      return this.$root.$t(
        'contract.status.' +
          this.contract.status +
          (!this.contract.esign && ['PENDING', 'VALIDATED'].includes(this.contract.status)
            ? '.messageManuel'
            : '.message'),
      )
    },
    alertClass() {
      if (
        ['CREATED', 'VALIDATED', 'STUDY', 'STUDIED', 'PENDING', 'CLIENT_SIGNED', 'DELIVERED'].includes(
          this.contract.status,
        )
      ) {
        return 'alert-light'
      }
      return 'alert-success'
    },
    hideDelivery() {
      return (
        (['CHECKED', 'PENDING', 'STUDIED', 'CLIENT_SIGNED'].includes(this.contract.status) &&
          !this.contract.withoutOrder) ||
        ['CREATED', 'VALIDATED', 'STUDY'].includes(this.contract.status)
      )
    },
    showSetup() {
      return ['DELIVERED', 'COMPLETE'].includes(this.contract.status)
    },
    showCession() {
      return this.contract.status === 'COMPLETE'
    },
    wrapperStyle() {
      const styles = {}
      if (this.contract.status === 'CREATED') {
        styles['marginTop'] = '60px'
      }

      return styles
    },
  },
  methods: {
    changeLink(page) {
      this.page = page
    },
    changePageStatus() {
      let page = ''
      let env = ['novalend', 'fiparc', 'ciscar', 'eurolocatique']
      let urlParams = new URLSearchParams(window.location.search)
      let statusContract = ['CREATED']
      let statusDelivery = ['ORDERED', 'WAITING', 'COMPLETE', 'COMPANY_SIGNED', 'PAID', 'DELIVERED']
      let statusDocuments = ['CLIENT_SIGNED', 'CHECKED', 'PENDING', 'STUDY', 'STUDIED', 'VALIDATED']
      let statusSetup = ['COMPLETED']
      if (statusDelivery.includes(this.contract.status)) {
        if (this.hasRole('ROLE_DELIVERY_SHOW') && this.contract.isDeliveryAvailable) {
          page = 'delivery'
        } else {
          page = 'documents'
        }
      } else if (statusDocuments.includes(this.contract.status)) {
        page = 'documents'
      } else if (statusContract.includes(this.contract.status)) {
        page = 'contract'
      } else if (statusSetup.includes(this.contract.status) && env.includes(conf.theme_dir)) {
        page = 'setup'
      } else if (conf.theme_dir === 'lbp' && statusSetup.includes(this.contract.status)) {
        page = 'delivery'
      }

      let allowedPage = ['active-and-services']
      if (this.hasRole('ROLE_COMMENTS_SHOW')) {
        allowedPage.push('comments')
      }
      if (this.hasRole('ROLE_CONTRIBUTORS_SHOW')) {
        allowedPage.push('actors')
      }
      if (user?.isBusinessMan && this.hasRole('ROLE_PROFITABILITY_SHOW')) {
        allowedPage.push('profitability')
      }
      if (allowedPage.includes(urlParams.get('p'))) {
        page = urlParams.get('p')
      }

      if (this.uuid && urlParams.get('p') === 'delivery') {
        page = 'delivery'
      }

      return page
    },
    getContract() {
      let url = `v2/contracts/${this.contractId}/def`

      if (this.uuid) {
        url = `free/${url}?uniqid=${this.uuid}`
      }

      this.getJSON(url).then((json) => {
        let statusPortfolio = ['PAID', 'FINISH', 'ENDED', 'CLOSED', 'PROLONGATION', 'CESSION']
        if (statusPortfolio.includes(json.contract.status)) {
          window.location = `/portefeuille/portefeuille.php?i=${json.contract.id}&p=detail`
        } else {
          this.$root.addValue(this.contract, json.contract)
          this.contractNumber = json.contract.number
          this.$root.addValue(this.def, json.config)
          this.getAlert()
          if (!this.page) {
            this.page = this.changePageStatus()
          }
          this.contractLoaded = true
        }
      })
    },
    alertInfo(json) {
      if (json.length > 0) {
        const alertStatus = json.map((alert) => alert.status)
        const alertBlocking = json.some((alert) => alert.type?.blocking)

        const createdAlerts = alertStatus.filter((status) => ['CREATED', 'SENT'].includes(status))

        this.alertInformation = {
          number: createdAlerts.length,
          status: alertStatus.every((status) => status === 'ARCHIVED') ? 'ARCHIVED' : 'CREATED',
          blocking: alertBlocking,
        }
      } else {
        this.alertInformation.number = 0
      }

      if (!this.alertInformation.blocking) {
        this.contract.blockedAt = false
      }
    },
    showAlertList() {
      this.showAlert = !this.showAlert
    },
    getAlert() {
      if (this.$refs.alertlist) {
        this.$refs.alertlist.loadAlert()
      }
    },
    setContract(contract) {
      this.contract = contract
    },
    async fetchOutstandings() {
      this.loadOutstandings = true
      this.outstandings = await this.getJSON(`contracts/${this.contractId}/portefeuille/outstandings`)
      this.loadOutstandings = false
    },
  },
  watch: {
    page: {
      async handler(page) {
        if (page === 'outstanding') {
          await this.fetchOutstandings()
        } else {
          this.outstandings = []
        }
      },
      immediate: true,
    },
    'contract.finance.amount': function () {
      this.getContract()
    },
  },
  mounted() {
    window.addEventListener('popstate', (event) => {
      this.page = this.changePageStatus()
    })
  },

  beforeMount() {
    this.getContract()
  },
}
</script>
<template>
  <PageLayout menu="contrats-index">
    <MainContainer>
      <MainContent v-if="contract">
        <template v-if="isLogged && Object.entries(contract).length > 0 && contract.status !== 'CREATED'">
          <ContractMenu
            :contract="contract"
            :active="page"
            :alert-information="alertInformation"
            @link="changeLink"
            @show-alert="showAlertList"
          />
        </template>
        <div :style="wrapperStyle">
          <h5
            v-if="contract.status && isTheme('lbp')"
            class="subtitle text-center alert"
            :class="alertClass"
            role="alert"
            v-html="titleMessage"
          ></h5>

          <AlertList
            ref="alertlist"
            v-if="hasRole('ROLE_ALERT_SHOW') && Object.entries(contract).length > 0"
            context="AppBundle\Entity\Contract"
            :context-id="Number(contractId)"
            :show="showAlert"
            :object="contract"
            @alert-info="alertInfo"
          />

          <div v-if="contractLoaded">
            <ContractInformation
              v-if="page === 'contract'"
              :contract-id="contractId"
              :def="def"
              v-model:contract="contract"
            />
            <ContractAssetsAndServices
              v-if="page === 'active-and-services'"
              :contract="contract"
              :def="def"
              @set-contract="setContract"
              @reload-data="getContract"
            />
            <ContractDocument
              v-if="page === 'documents'"
              :contract-id="contractId"
              :contract-number="contractNumber"
              :contract="contract"
              :def="def"
            />
            <ContractDelivery
              v-if="page === 'delivery'"
              :contract-id="contractId"
              :contract="contract"
              :def-contract="def"
              :uuid="uuid"
            />
            <ContractSetup v-if="page === 'setup'" :id="Number(contractId)" :contract="contract" :def="def" />
            <ContractCession v-if="page === 'cession'" :id="contractId" :contract="contract" :def="def" />
            <Profitabilities
              v-if="page === 'profitability' && hasRole('ROLE_PROFITABILITY_SHOW')"
              :id="contractId"
              context="contracts"
              :wallet="false"
            />
            <Actors
              v-if="page === 'actors'"
              :id="Number(contractId)"
              endpoint="contracts"
              :context="contract"
              @reload-data="getContract"
            />
            <Comments v-if="page === 'comments'" :simulation-id="contract.simulationId" :contract-id="contractId" />
            <ContractRestructuringView
              v-if="page === 'restructuring' && hasRole('ROLE_RESTRUCTURING')"
              :restructuring="contract.finance.restructuring"
              :contract-id="Number(contract.id)"
            />
            <Outstanding v-if="page === 'outstanding'" :loading="loadOutstandings" :outstandings="outstandings" />
          </div>
          <div v-else class="row justify-content-center">
            <div class="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </MainContent>
    </MainContainer>
  </PageLayout>
</template>
